import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/tradesy-vacation-mode';

export default function Example() {
  return (
    <>
      <Head>
        <title>Take a selling break in peace with Tradesy Vacation Mode</title>
        <meta
          name='description'
          content='Your listings and potential sales need not go on a break with you. Keep your items visible with this must-know Tradesy seller feature.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/tradesy-vacation-mode' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/tradesy-vacation-mode' />
        <meta property='og:title' content='Take a selling break in peace with Tradesy Vacation Mode' />
        <meta
          property='og:description'
          content='Your listings and potential sales need not go on a break with you. Keep your items visible with this must-know Tradesy seller feature.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-08-05T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-08-05T00:00:00-00:00' />
        <meta property='article:tag' content='Tradesy' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
